import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_BASE } from './api';
import { ScrapeRun, ScrapeRunResponse, ScrapeStatus, ScrapeStopResponse } from '../models';

@Injectable({ providedIn: 'root' })
export class AdminService {
  constructor(private readonly http: HttpClient) {}

  status() {
    return this.http.get<ScrapeStatus>(`${API_BASE}/admin/scrape/status`);
  }

  logs(runId?: string) {
    const suffix = runId ? `?runId=${encodeURIComponent(runId)}` : '';
    return this.http.get<unknown[]>(`${API_BASE}/admin/scrape/logs${suffix}`);
  }

  runs() {
    return this.http.get<ScrapeRun[]>(`${API_BASE}/admin/scrape/runs`);
  }

  run() {
    return this.http.post<ScrapeRunResponse>(`${API_BASE}/admin/scrape/run`, {});
  }

  stop() {
    return this.http.post<ScrapeStopResponse>(`${API_BASE}/admin/scrape/stop`, {});
  }
}
